var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-table',{attrs:{"apiName":_vm.apiName,"nameRole":_vm.nameRoleEntity,"titleTable":_vm.$t('Контрагенты'),"paramsGetData":_vm.paramsGetData,"fieldLand":_vm.fieldLang,"keyTable":'counterpartyId',"deleteParams":_vm.deleteParams,"apiDeleteName":'',"forceIsEdit":false,"forceIsCreate":false,"forceDelete":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }